import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-operations-header',
  templateUrl: './operations-header.component.html',
  styleUrls: ['./operations-header.component.scss'],
  standalone: false,
})
export class OperationsHeaderComponent {
  @Input()
  header!: string;

  @Input()
  subHeader!: string;

  @Input()
  hasToggleBtn = false;
}
